<template>
  <b-container>
    <div class="reg-tab-container mb-3 mt-3">
      <b-row>
        <b-col>
          <b-row>
            <b-col md="3">
              <b style="font-size:14px">Bank Name:</b>
            </b-col>
            <b-col style="font-size:14px">{{LoanDetails.BankName}}</b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <b-col md="3">
              <b style="font-size:14px">Branch Name:</b>
            </b-col>
            <b-col style="font-size:14px">{{LoanDetails.BranchName}}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <b-col md="3">
              <b style="font-size:14px">Approved Amount:</b>
            </b-col>
            <b-col>&#8377;{{LoanDetails.SanctionAmount}}</b-col>
            <b-col md="3">
              <b style="font-size:14px">Disbursed Amount:</b>
            </b-col>
            <b-col md="3">&#8377;{{LoanDetails.DisbursementAmount}}</b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <b-col md="3" style="font-size:14px">
              <b>Interest Rate %:</b>
            </b-col>
            <b-col md="1" style="font-size:14px">{{LoanDetails.ROI}}</b-col>
            <b-col md="3" style="font-size:14px">
              <b>Tenure (months):</b>
            </b-col>
            <b-col md="1" style="font-size:14px">{{LoanDetails.LoanTenure}}</b-col>
            <b-col>
              <b-button
                @click="Add"
                size="sm"
                variant="success"
                style="float:right"
              >Add New Disbursal</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col></b-col>
      <b-col md="4"></b-col>
    </b-row>

    <b-row class="mb-2">
      <b-col md="4">
        <b-input-group>
          <b-form-input v-model="filter" placeholder="Type to Search" size="sm" />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col></b-col>
      <b-col md="4">
        <b-form-group horizontal label="Sort" class="mb-0" label-size="sm" label-cols="1">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div v-if="isLoading" class="text-center py-4">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      <div class="mt-2">Loading disbursals...</div>
    </div>
    <b-table
      v-else
      show-empty
      selectable
      select-mode="single"
      head-variant="dark"
      empty-text="No Disbursal available."
      stacked="md"
      bordered
      striped
      :items="disbursals"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFiltered"
      style="font-size:12px"
    >
      <!-- <template v-slot:cell(selected)="{ rowSelected }"> -->
      <!-- <template v-slot:cell(selected)="row">
        <template v-if="row.rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not Selected</span>
        </template>
      </template>-->
      <template v-slot:cell(action)="row">
        <a target="_blank" style="font-size:0.875rem" :href="getImgUrl(row.item)">Letter</a>

        <a
          v-if="row.item.UploadBankStatement && row.item.UploadBankStatement != ''"
          target="_blank"
          style="font-size:0.875rem;margin-left:0.5rem"
          :href="getBankRepaymentUrl(row.item)"
        >Repayment Schedule</a>

        <b-button
          size="sm"
          @click.stop="viewDisbursal(row.item)"
          class="ml-2 pt-0 pb-1"
          variant="link"
        >EMI</b-button>

        <b-button
          size="sm"
          @click.stop="uploadSchedule(row.item)"
          class="ml-2 pt-0 pb-1"
          variant="link"
          v-if="row.item.UploadDisburmentLetter ==''"
        >Upload Payment Schedule</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
          <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-modal ref="modalEmi" title="EMI Schedule" size="lg">
      <b-table
        ref="emiTable"
        show-empty
        head-variant="dark"
        empty-text="No Schedule available."
        stacked="md"
        bordered
        striped
        :items="emiList"
        :fields="emifields"
        :current-page="emicurrentPage"
        :per-page="emiperPage"
        :filter="emifilter"
        :sort-by.sync="emisortBy"
        :sort-desc.sync="emisortDesc"
        style="font-size:12px"
      >
        <template v-slot:cell(SL)="row">
          <span aria-hidden="true">{{row.index+1+(10*(emicurrentPage-1))}}</span>
        </template>
        <template v-slot:cell(IsDue)="row">
          <span aria-hidden="true">{{row.item.IsDue?'Yes':''}}</span>
        </template>
      </b-table>
      <b-row>
        <b-col md="8" class="my-1">
          <b-pagination
            :total-rows="emitotalRows"
            :per-page="emiperPage"
            v-model="emicurrentPage"
            class="my-0"
            size="sm"
          />
        </b-col>
        <b-col md="4" class="my-1">
          <b-form-group horizontal label="Per page" class="mb-0" label-size="sm" :label-cols="6">
            <b-form-select :options="emipageOptions" v-model="emiperPage" size="sm" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      ref="mdlUploadSchedule"
      title="Upload Repayment /EMI/Amortization Schedule"
      hide-footer
    >
      <b-form>
        <div class="row">
          <div class="col-md-4">
            <span class="ln-eng" style="font-size: 0.875rem;">EMI Schedule *</span>
            <p style="font-size: 0.75rem;color:#2284ab;">Upload All pages of EMI schedule</p>
          </div>
          <div class="col-md-4">
            <b-form-file
              ref="fiFilePath"
              @change="onFileChange"
              v-if="form.UploadDisburmentLetter =='' || !form.UploadDisburmentLetter"
              accept=".jpg, .png, .gif, .pdf"
              size="sm"
              required
              class="mt-3"
              plain
            ></b-form-file>
          </div>
          <div
            class="col-md-4"
            v-if="formUpld.UploadAmortizationSchedule!='' && formUpld.UploadAmortizationSchedule"
          >
            <a :href="getImgUrl2(formUpld.UploadAmortizationSchedule)" target="_blank">
              <img
                style="height:30px"
                :src="getImgUrl(formUpld.UploadAmortizationSchedule)"
                class="img-fluid"
              />
            </a>
            <b-button
              size="sm"
              style="margin-left:0.5rem"
              @click.stop="deleteDocument2('emischedule', formUpld.UploadAmortizationSchedule)"
              class="mr-1 pt-0 pb-0"
              variant="outline-danger"
              v-b-tooltip.hover
              title="Delete Document"
              v-if="!LockProfile"
            >
              <i class="fa fa-trash" style="font-size:16px;color:red"></i>
            </b-button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <b-button class="float-right" variant="success" @click="uploadEMIFile">Upload File</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import * as _ from "lodash";
import axios from "axios";
import Formatter from "@/Formatter";
import Spinner from "vue-simple-spinner";
import common from "@/apis/common";

export default {
  components: { Spinner },
  data() {
    return {
      show: false,
      showsts: false,
      modalInfo: "",
      districts: [],
      schemes: [],
      approvalStatus: [],
      disbursals: [],
      bscReport: "",
      bscReportPath: "",
      fields: [
        { key: "LoanApplicationNo", label: "Application No", sortable: true },
        {
          key: "DisbursalDate",
          label: "Disbursal Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        { key: "DisburmentAmount", label: "Disbursed Amount", sortable: true },
        { key: "EmiAmount", label: "EMI", sortable: true },
        {
          key: "EmiStartDate",
          label: "Emi Start Date",
          sortable: true,
          formatter: "convertDateFormat"
        },
        {
          key: "EmiEndDate",
          label: "EMI End Date",
          formatter: "convertDateFormat"
        },
        { key: "LoanTenure", label: "Tenure Months" },
        { key: "Status", label: "Status", sortable: true },
        { key: "action", label: "View" }
      ],
      selected: [],
      form: {
        DistrictID: "",
        ApplicationStatusID: 0,
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: ""
      },
      formUpld: {
        UploadAmortizationSchedule: "",
        UpdatedBy: "",
        LoanDisbursementID: ""
      },
      Photo: null,
      selectedApplication: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0
      },
      emiList: [],
      emifields: [
        { key: "SL", label: "Sr No" },
        { key: "EMIDate", label: "Month", formatter: "convertDateFormat" },
        { key: "EMIAmount", label: "EMI" },
        { key: "OpeningBalance", label: "Opening Amount" },
        { key: "PrincipalAmount", label: "Principal" },
        { key: "InterestAmount", label: "Interest" },
        { key: "ClosingBalance", label: "Balance" },
        { key: "IsDue", label: "Due Claim" }
      ],
      emicurrentPage: 1,
      emiperPage: 10,
      emitotalRows: 0,
      emipageOptions: [10, 15, 20, 30, 60],
      emisortBy: null,
      emisortDesc: false,
      emifilter: null
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    uploadSchedule(item) {
      this.formUpld.LoanDisbursementID = item.LoanDisbursementID;
      this.$refs.mdlUploadSchedule.show();
    },
    async onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      this.Photo = files;
    },
    async uploadEMIFile(evt) {
      evt.preventDefault();
      let d = new Date();
      let response = await common.onFileChange(
        this.Photo,
        "EMISchedule_" + d * 1 + "."
      );

      if (response.status) {
        this.formUpld.UploadAmortizationSchedule = response.message;
      } else {
        this.$dialog.alert("ERROR while uploading file");
        this.$refs.fiFilePath.reset();
        // this.alertText = response.message;
        // this.variant = "danger";
        // this.showDismissibleAlert = true;
        return;
      }

      var userinfo = this.$store.getters.loggedUser;
      this.formUpld.UpdatedBy = userinfo.UserId;
      let promise = apis.UploadEmiSchedule(this.formUpld);
      promise
        .then(response => {
          if (response.status == 200) {
            this.$dialog.alert("File Saved Successfully");
            this.$refs["mdlUploadSchedule"].hide();
          }
        })
        .catch(err => {
          this.$dialog.alert("ERROR while saving file");
          this.$refs["mdlUploadSchedule"].hide();
        });
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getImgUrl(pic) {
      if (pic) {
        if (pic.UploadDisburmentLetter.split(".").pop() == "pdf") {
          return require("@/assets/Pdf.jpg");
        }
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.UpdatedBy +
          "/" +
          pic.UploadDisburmentLetter
        );
      }
    },

    getBankRepaymentUrl(pic) {
      if (pic && pic.UploadBankStatement) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.UpdatedBy.toLowerCase() +
          "/" +
          pic.UploadBankStatement
        );
      }
    },

    getImgUrl2(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.UpdatedBy.toLowerCase() +
          "/" +
          pic.UploadDisburmentLetter
        );
      }
    },
    Add() {
      this.$router.push("/newdisbursal");
    },
    viewDisbursal(item) {
      //alert(JSON.stringify(item));
      let promise = apis.getSeheduleByDisbursement(item.LoanDisbursementID);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.emiList = response.body;
            this.emitotalRows = response.body.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
      this.$refs.modalEmi.show();
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getSanctionLetterDetails() {
      let userid = this.$store.getters.loggedUser.UserId;

      let promise = apis.ReadSanctionLetterByUserID(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.LoanDetails = response.body;
            this.$store.dispatch("setSanctionLetter", this.LoanDetails);
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    getDisbursals() {
      this.isLoading = true;
      this.showDismissibleAlert = false;
      let userid = this.$store.getters.loggedUser.UserId;

      let promise = apis.ReadLoanDisbursementByUserID(userid);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.disbursals = response.body;
            this.totalRows = this.disbursals.length;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      //console.log(this.selectedDistrict);
    }
  },
  mounted() {
    this.getDisbursals();
    this.getSanctionLetterDetails();
    //this.getApprovalStatus();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LoanDisbursal/DisbursalList.vue